module.exports = __webpack_public_path__ + "static/media/arrow-right.cf2f4b19.svg";